import { fetchDrmTableData } from "../../service/fetchDrmTableData";
import { setDrmChangeLogTableDataSuccess, setDrmChangeLogTableDataFailure } from "../reducers/drmChangeLogTableDataSlice";
import { put, takeLatest, call, cancelled } from "redux-saga/effects";
import { parseChangeLogTableData } from "./drmDataMapper";

export function* workerGetChangeLogDrmTableDataFetch({ payload }) {
  const controller = new AbortController();
  try {
    const response = yield call(fetchDrmTableData, [
      payload.pageNum,
      payload.reqBody,
      payload.pageSize,
      payload.tableName,
      controller,
    ]);

    const data = response.data;
    const parsedShipmentValues = parseChangeLogTableData(data, {
      includeRawDailyDates: true,
      preserveUndefinedShipmentAllocations: true,
    });

    const rest =
      payload.tableName === "drmChangeLogTableData"
        ? {
            onPage: data?.details?.onPage,
            pageSize: data?.details?.pageSize,
            totalPages: data?.details?.totalPages,
            totalRecords: data?.details?.totalRecords,
          }
        : { ...data };

    yield put(
      setDrmChangeLogTableDataSuccess({
        ...rest,
        drmMaintenanceDetails: parsedShipmentValues
      })
    );
  } catch (error) {
    yield put(
      setDrmChangeLogTableDataFailure({
        error: error.toString()
      })
    );
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmChangeLogTableDataSaga() {
  yield takeLatest("drmChangeLogTableData/getDrmChangeLogTableData", workerGetChangeLogDrmTableDataFetch);
}

export default drmChangeLogTableDataSaga;